import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../../service/getNumberOfLayers"
import resolveEmcShieldSideName from "../../../../../service/sideNameResolver/resolveEmcShieldSideName"
import type { OneClickFieldProps } from "../../../../../types"
import ColorPattern from "../../../../components/1Click/form/ColorPattern/ColorPattern"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./emcShield.png"

const 電磁波シールド = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { emcShield: shouldShow } = getDisplayCondition(values)
  const numberOfLayers = getNumberOfLayers(values)

  const id = (() => {
    if (numberOfLayers === 1) return "片面"
    if (numberOfLayers === 2) return "2層"
    if (numberOfLayers === 3) return "3層"
    if (numberOfLayers === 4) return "4層"
  })()
  if (!id) return null

  const both = <ColorPattern pattern="both" values={values} />
  const top = <ColorPattern pattern="top" values={values} />
  const bottom = <ColorPattern pattern="bottom" values={values} />
  const none = <ColorPattern pattern="none" values={values} />

  return (
    <OneClickField isShow={shouldShow} legend="電磁波シールド" helpURL={HELP_LINKS.電磁波シールド} src={img}>
      <RadioGroup name={FIELD_NAMES.電磁波シールド} selectedValue={values.emcShield} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.電磁波シールド[`両面貼る(${id})`].value} prefixNode={both}>
            両面貼る
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.電磁波シールド[`パターン面と同じ面を貼る(L1面を貼る)(${id})`].value}
            prefixNode={top}
          >
            {resolveEmcShieldSideName(
              ESTIMATE_CONSTANT.電磁波シールド[`パターン面と同じ面を貼る(L1面を貼る)(${id})`].value,
              values
            )}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.電磁波シールド[`パターン面と逆の面を貼る(Ln面を貼る)(${id})`].value}
            prefixNode={bottom}
          >
            {resolveEmcShieldSideName(
              ESTIMATE_CONSTANT.電磁波シールド[`パターン面と逆の面を貼る(Ln面を貼る)(${id})`].value,
              values
            )}
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.電磁波シールド[`貼らない(${id})`].value} prefixNode={none}>
            貼らない
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.emcShield} />
    </OneClickField>
  )
}

export default 電磁波シールド
